import React from 'react';

function Music() {
  return (
    <main className="page-content">
      <section className="page-hero">
        <h1>Music</h1>
        <p>Explore our discography and latest releases</p>
      </section>

      <section className="albums-section">
        <h2>Albums & EPs</h2>
        <div className="albums-grid">
          <div className="album-card">
            <a href="https://open.spotify.com/track/3yetMDl9ZULqGoTNcn8UvQ?si=c6add1d3873846b5" target="_blank" rel="noopener noreferrer">
              <img src="/images/album-covers/dopegnome cover.jpeg" alt="Dopegnome Album Cover" className="album-image" />
            </a>
            <h3>Dopegnome</h3>
            <p>Latest Release</p>
            <div className="streaming-links">
              <a href="https://open.spotify.com/track/3yetMDl9ZULqGoTNcn8UvQ?si=c6add1d3873846b5" target="_blank" rel="noopener noreferrer" className="stream-link">Spotify</a>
              <a href="https://music.apple.com/us/song/invitation/1832454791" target="_blank" rel="noopener noreferrer" className="stream-link">Apple Music</a>
              <a href="https://music.youtube.com/watch?v=YRymZIyYkes&si=0vPu6BWEX7mMFDQF" target="_blank" rel="noopener noreferrer" className="stream-link">YouTube Music</a>
              <a href="https://music.amazon.com/tracks/B0FLW37M34?marketplaceId=ATVPDKIKX0DER&musicTerritory=US&ref=dm_sh_DifYhJKzvskKtt8TAXknMCOQY" target="_blank" rel="noopener noreferrer" className="stream-link">Amazon Music</a>
            </div>
          </div>
          <div className="album-card">
            <a href="https://open.spotify.com/track/7bK6MX7tnLWg5TVwCyGAMo?si=72c88cf54bca4db1" target="_blank" rel="noopener noreferrer">
              <img src="/images/album-covers/twisted wizard.JPG" alt="Twisted Wizard Album Cover" className="album-image" />
            </a>
            <h3>Twisted Wizard</h3>
            <p>Previous Release</p>
            <div className="streaming-links">
              <a href="https://open.spotify.com/track/7bK6MX7tnLWg5TVwCyGAMo?si=72c88cf54bca4db1" target="_blank" rel="noopener noreferrer" className="stream-link">Spotify</a>
              <a href="https://music.apple.com/us/song/twisted-wizard/1787799174" target="_blank" rel="noopener noreferrer" className="stream-link">Apple Music</a>
              <a href="https://music.youtube.com/watch?v=1S-q10IJ4So&si=530_-Oxy5_YDpoxZ" target="_blank" rel="noopener noreferrer" className="stream-link">YouTube Music</a>
              <a href="https://music.amazon.com/tracks/B0DRM4SNHS?marketplaceId=ATVPDKIKX0DER&musicTerritory=US&ref=dm_sh_mb4G4M52bI1j3m33rcWVsbDQq" target="_blank" rel="noopener noreferrer" className="stream-link">Amazon Music</a>
            </div>
          </div>
        </div>
      </section>

      <section className="embedded-player">
        <h2>Listen Now</h2>
        <div className="streaming-services">
          <div className="service-grid">
            <a href="https://open.spotify.com/artist/55KU1zwKy2V6LW40wVLwEJ?si=RDh7G0RySumEH5djutT1Jg" target="_blank" rel="noopener noreferrer" className="service-link spotify">
              <span className="service-name">Spotify</span>
            </a>
            <a href="https://music.apple.com/us/artist/wormwagon/15564903" target="_blank" rel="noopener noreferrer" className="service-link apple">
              <span className="service-name">Apple Music</span>
            </a>
            <a href="https://music.youtube.com/channel/UCQZQZQZQZQZQZQZQZQZQZQ" target="_blank" rel="noopener noreferrer" className="service-link youtube">
              <span className="service-name">YouTube Music</span>
            </a>
            <a href="https://music.amazon.com/artists/B0F1KX6MXV/wormwagon" target="_blank" rel="noopener noreferrer" className="service-link amazon">
              <span className="service-name">Amazon Music</span>
            </a>
            <a href="https://tidal.com/browse/artist/12345678" target="_blank" rel="noopener noreferrer" className="service-link tidal">
              <span className="service-name">Tidal</span>
            </a>
            <a href="https://www.deezer.com/us/artist/12345678" target="_blank" rel="noopener noreferrer" className="service-link deezer">
              <span className="service-name">Deezer</span>
            </a>
            <a href="https://soundcloud.com/wormwagon" target="_blank" rel="noopener noreferrer" className="service-link soundcloud">
              <span className="service-name">SoundCloud</span>
            </a>
            <a href="https://wormwagon.bandcamp.com" target="_blank" rel="noopener noreferrer" className="service-link bandcamp">
              <span className="service-name">Bandcamp</span>
            </a>
            <a href="https://www.pandora.com/artist/wormwagon" target="_blank" rel="noopener noreferrer" className="service-link pandora">
              <span className="service-name">Pandora</span>
            </a>
            <a href="https://www.iheart.com/artist/wormwagon" target="_blank" rel="noopener noreferrer" className="service-link iheart">
              <span className="service-name">iHeartRadio</span>
            </a>
            <a href="https://www.last.fm/music/WormWagon" target="_blank" rel="noopener noreferrer" className="service-link lastfm">
              <span className="service-name">Last.fm</span>
            </a>
            <a href="https://www.shazam.com/artist/wormwagon" target="_blank" rel="noopener noreferrer" className="service-link shazam">
              <span className="service-name">Shazam</span>
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Music;